import { StudyTab } from "./studyscreeningtabs.types";

 export const VolunteerStudyScreeningTabs: StudyTab[] = [
    {
      key: "detail",
      label: "Details",
      icon: "ri-file-list-3-line", // Perfect for details
      path: "",
    },
    {
      key: "icf",
      label: "ICF",
      icon: "ri-file-upload-line", // Updated icon for ICF
      path: "icf",
    },
     {
      key: "test",
      label: "Test",
      icon: "ri-file-list-3-line", // Perfect for details
      path: "test",
    },
    {
      key: "screening",
      label: "Screening",
      icon: "ri-search-eye-line",
      path: "screening",
    }
  ]